import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

// import styles bundle
import 'swiper/swiper.css';
import 'swiper/css/pagination';

document.addEventListener('alpine:init', () => {
    Alpine.data('initBlogSlider', () => {
        return {
            swiper: {},
            init() {
                const swiperParams: SwiperOptions = {
                    modules: [Navigation, Keyboard, Pagination],
                    init: false,
                    loop: true,
                    slidesPerView: 1,
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        prevEl: this.$refs.buttonPrev,
                        nextEl: this.$refs.buttonNext,
                    },
                    pagination: {
                        clickable: true,
                        el: this.$refs.pagination,
                        type: 'progressbar',
                    },
                };

                const swiper = new Swiper(
                    this.$refs.swiperContainer,
                    swiperParams,
                );
                this.swiper = swiper;

                this.$nextTick(() => {
                    swiper.init();
                });
            },
        };
    });
});
